import React from 'react';
import PropTypes from 'prop-types';
import Grid from '@material-ui/core/Grid';
import InputAdornment from '@material-ui/core/InputAdornment';
import FormTextField from '../form/FormTextField';
import FormSelect from '../form/FormSelect';
import model from './assets/models/model';

const JobPostingFields = ({ disabled }) => {
  return (
    <Grid container spacing={2}>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.jobId.id}
          label={`${model.jobId.name} (${model.jobId.summary})`}
          disabled
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          autoFocus
          id={model.jobTitle.id}
          label={model.jobTitle.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.hourlyRate.id}
          label={model.hourlyRate.name}
          disabled={disabled}
          placeholder="TBD"
          InputProps={{
            startAdornment: <InputAdornment position="start">$</InputAdornment>,
          }}
          onBlur={(e) => {
            if (
              !Number.isNaN(Number(e.target.value)) &&
              Number(e.target.value) !== 0
            ) {
              return (Math.round(Number(e.target.value) * 100) / 100).toFixed(
                2
              );
            }
            return e.target.value;
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.shift.id}
          label={model.shift.name}
          disabled={disabled}
          options={model.shift.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.schedule.id}
          label={model.schedule.name}
          disabled={disabled}
          options={model.schedule.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.teleworking.id}
          label={model.teleworking.name}
          disabled={disabled}
          options={model.teleworking.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.usCitizenshipRequired.id}
          label={model.usCitizenshipRequired.name}
          disabled={disabled}
          options={model.usCitizenshipRequired.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.minimumClearance.id}
          label={model.minimumClearance.name}
          disabled={disabled}
          options={model.minimumClearance.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.polygraphType.id}
          label={model.polygraphType.name}
          disabled={disabled}
          options={model.polygraphType.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.travel.id}
          label={model.travel.name}
          disabled={disabled}
          options={model.travel.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.travelPercentage.id}
          label={model.travelPercentage.name}
          disabled={disabled}
          InputProps={{
            endAdornment: <InputAdornment position="end">%</InputAdornment>,
          }}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.jobLocation.id}
          label={model.jobLocation.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormSelect
          id={model.educationRequired.id}
          label={model.educationRequired.name}
          disabled={disabled}
          options={model.educationRequired.options}
          fullWidth
        />
      </Grid>
      <Grid item xs={6} sm={4}>
        <FormTextField
          id={model.majorSpecialization.id}
          label={model.majorSpecialization.name}
          disabled={disabled}
          fullWidth
        />
      </Grid>
      <Grid item xs={12}>
        <FormTextField
          id={model.jobDescription.id}
          label={model.jobDescription.name}
          disabled={disabled}
          minRows={5}
          variant="outlined"
          multiline
          fullWidth
        />
      </Grid>
    </Grid>
  );
};

JobPostingFields.defaultProps = {
  disabled: false,
};

JobPostingFields.propTypes = {
  disabled: PropTypes.bool,
};

export default JobPostingFields;
